import { ILight } from '../lightTemplate';

type IAmbientLightProps = {
  instanceId: string;
  light?: ILight | undefined;
};

export const AmbientLight = (props: IAmbientLightProps) => {
  const lightRef = props.light?.ref;

  return (
    <ambientLight
      ref={lightRef}
      color={props.light?.color !== undefined ? props.light.color : 0xffffff}
      intensity={
        props.light?.intensity !== undefined ? props.light.intensity : 1
      }
      position={[0, 0, 0]}
      key={`light-${props.instanceId}`}
    />
  );
};
